import React from 'react'
import './styles/prova_vida.css'
import './styles/estilo.css'
import FadeIn from 'react-fade-in';
import { tela_fluxo } from '../telas_id'
import Loading from '../components/Loading'

import FaceDetect from '../components/FaceDetect'

import Countdown from "react-countdown";

import { RastreioText} from './text/prova_vida.text'

import { SeguirBtn } from './styles/estilo_prova_vida'
import {status, situacao} from '../components/Info'

import { PropTelaProvaVida } from '../ts/interfaces/PropTelas.interfaces';
import Webcam from 'react-webcam';
import { addInfo, updateInfoBPO } from '../state/actions/Info_actions';
import ErroIdentificacao from '../components/screen_components/ErroIdentificacao.component';
import { setStateJornada } from '../state/actions/jornada_actions';
import { PPVida } from '../ts/types/Types';

interface State {
  px: number,
  py: number,
  size: number,
  movimento: number,
  resumo: PPVida,
  step: number,
  tentativa: number,
  carregando: boolean,
  seconds: number
}

const tela = {
  captura_prova_vida: 0,
  erro_de_captura: 1
}

const {REACT_APP_PERFIL} = process.env

export default class ProvadeVida extends React.Component<PropTelaProvaVida, State> {
  webcam: React.RefObject<Webcam>

  constructor(props : PropTelaProvaVida){
    super(props)
    // props: insertScreenshot, AddEvento, ChangePasso
    this.onUpdatePos = this.onUpdatePos.bind(this)
    this.onUpdatePosSave = this.onUpdatePosSave.bind(this)
    this.onRecord = this.onRecord.bind(this)
    this.sendRecord = this.sendRecord.bind(this)
    this.ErroCaptura = this.ErroCaptura.bind(this);
    this.onUpdateFace = this.onUpdateFace.bind(this)
    this.onUpdateCounter = this.onUpdateCounter.bind(this)
    this.onFinishCount = this.onFinishCount.bind(this)

    this.webcam = React.createRef<Webcam>();

    this.state = {
      px: 0,
      py: 0,
      size: 0,
      movimento: -1,
      resumo: {movimento_concluido: 0, prova_vida_suspeita: false, etapas: {sorriso: false, rosto_direita: false, rosto_esquerda: false}},
      seconds: -1,
      carregando: false,
      tentativa: 0,
      step: tela.captura_prova_vida
    }

  }

  componentDidMount() {
    updateInfoBPO({fase: status.tela_prova_vida, situacao: situacao.sucesso});
    addInfo(tela_fluxo.prova_vida);
  }

  onUpdatePos(value : number, x : number =0, y : number =0, size: number =0){
    //console.log(value)
    if(x != 0 && y != 0 && size != 0){
      this.setState({px: x, py: y, size: size})
    }
    this.setState({movimento: value})
  }

  onUpdatePosSave(value : number){
    this.setState({movimento: value})
  }

  onRecord(blob : Blob){ //onRecord é chamado depois de sendRecord
    this.props.InsertVideoBlob(blob as Blob);
    let { resumo } = this.state;
    if(resumo.movimento_concluido > 0){
      updateInfoBPO({fase: status.prova_vida_capturada, situacao: situacao.sucesso});
    }
  }

  sendRecord(){
    const {tentativa} = this.state;
    let {resumo} = this.state;

    if(resumo.movimento_concluido > 0){
      setStateJornada({ prova_vida: resumo });
      this.props.changePasso()
    }else if(tentativa > 0){
      this.setState({step: tela.erro_de_captura});
    }else{
      resumo.prova_vida_suspeita = true;
      setStateJornada({ prova_vida: resumo });
      this.props.changePasso()
    }
  }

  onUpdateFace(value : {x: number, y: number, felicidade: number}){
    const {movimento, px} = this.state
    let { resumo } = this.state;
    let p = value.x/px;
    const width = window.innerWidth;

    if(resumo.movimento_concluido == 0 && value.felicidade > 0.5){
      resumo.movimento_concluido += 1;
      resumo.etapas.sorriso = true;
      this.setState({ resumo })
    }else if(resumo.movimento_concluido == 1 && p < 0.8) {
      resumo.movimento_concluido += 1;
      resumo.etapas.rosto_direita = true;
      this.setState({ resumo });
    }else if(resumo.movimento_concluido == 2 && p > 1.2) {
      resumo.movimento_concluido += 1;
      resumo.etapas.rosto_esquerda = true;
      this.setState({ resumo });
    }

    if(movimento == -1 && (value.x >= width/2 + 10 || value.x <= width/2 - 10)){
      this.setState({movimento: 0, px: value.x })
    }else if((movimento == 0) && (value.felicidade > 0.5)){
      this.setState({movimento: 1 })
    }else if((movimento == 1) && (p < 0.8)){
      this.setState({movimento: 2 })
    }else if((movimento == 2) && (p > 1.2)){
      this.setState({movimento: 3 })
    }
  }

  onUpdateCounter({seconds}: {seconds: number}){
    return(<span>{seconds}</span>)
  }

  onFinishCount() {
    const {movimento} = this.state;
    if(movimento < 3){
      this.setState({movimento: movimento + 1})
    }
  }

  RastreioPersonalizado() { 
    const {movimento} = this.state
  
    const showMask = (movimento == -1)

    return(
      <FadeIn delay={50}>
        <div style={{marginTop: '50px', marginBottom: '100px'}}>
              {movimento != null?(
              <p id={REACT_APP_PERFIL == 'BPO'? 'font-command-mobile-bpo': 'font-command-mobile'}>
                {movimento == -1 && (<b>{RastreioText.movimento1}</b>)}
                {movimento == 0 && (<b>{RastreioText.movimento2} &#128512; ... <Countdown date={Date.now()+5000} intervalDelay={0} precision={3} renderer={this.onUpdateCounter} onComplete={this.onFinishCount} /></b>)}
                {movimento == 1 && (<b>{RastreioText.movimento3} ... <Countdown date={Date.now()+5000} intervalDelay={0} precision={3} renderer={this.onUpdateCounter} onComplete={this.onFinishCount} /></b>)}
                {movimento == 2 && (<b>{RastreioText.movimento4} ... <Countdown date={Date.now()+5000} intervalDelay={0} precision={3} renderer={this.onUpdateCounter} onComplete={this.onFinishCount} /></b>)}
                {movimento == 3 && (<b>{RastreioText.movimento5}</b>)}
              </p>
              ): null }

              <FaceDetect UpdateVal={this.onUpdateFace} InsertVideoBlob={this.onRecord} start={(movimento >= 0)} stop={(movimento >= 3)} showMask={showMask} timeRecord={0} />

              {movimento == 3 && (
                <SeguirBtn onClick={() => this.sendRecord()}/>
              )
              }
        </div>
      </FadeIn>
    );
  }

  ErroCaptura() {
    const {tentativa} = this.state;

    return(
      <ErroIdentificacao id='ProvaVida' 
        ReiniciarTentativa={()=>{ this.setState({
          step: tela.captura_prova_vida, 
          movimento: -1, 
          resumo: {
            movimento_concluido: 0, 
            prova_vida_suspeita: false, 
            etapas: {
              sorriso: false, 
              rosto_direita: false, 
              rosto_esquerda: false
            }},
            tentativa: tentativa - 1}) 
          }}
        tentativa={tentativa}
      />
    );
  }

  render(){
    const {enviado} = this.props;
    const {step} = this.state;

    if(!enviado){
      return(
        <div style={{marginTop: 20}}>
          <Loading text={'Carregando...'}/>
        </div>
      );
    }

    switch(step){
      case tela.captura_prova_vida:
        return(this.RastreioPersonalizado());
      case tela.erro_de_captura:
        return(this.ErroCaptura());
      default:
        break;
    }
    return(<></>)
  }
}